<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<ng-container *ngIf="!isStaticPage; else staticBlock">
  <ngx-loading-bar [includeSpinner]="false" [color]="loadingBarColor"></ngx-loading-bar>
  <!--<div class="file-upload" *ngIf="upload" appDnd (filesChangeEmiter)="onFilesChange($event)" (filesInvalidEmiter)="onFileInvalids($event)" [allowed_extensions]="['png', 'jpg', 'bmp']">-->
  <!--<div>-->
  <!--<rx-icon name="icon-share-arrow" class="mb20"></rx-icon>-->
  <!--<span>-->
  <!--Drag And Drop To Account Library-->
  <!--</span>-->
  <!--</div>-->
  <!--</div>-->
  <rx-navbar
    (navbarEvent)="navbarEvent($event)"
    [notificationAmount]="notificationAmount$ | async"
    [avatar]="userPhoto$ | async"
    [moreOptions]="userOptions"
    [email]="email$ | async"
    [username]="username$ | async"
    [user]="user$ | async"
    *ngIf="canShowHeader()"
  >
    <div class="flex flex-row" *ngIf="canShowNav()">
      <a
        id="navigate-clients"
        class="link"
        mat-flat-button
        [class.active-nav-bar-client]="isHeaderLinkActive('/clients')"
        routerLink="/clients"
      >
        Clients
      </a>
      <a
        class="link"
        id="navigate-inbox"
        mat-flat-button
        [class.active-nav-bar-client]="isHeaderLinkActive('/inbox')"
        routerLink="/inbox"
      >
        Forms
      </a>
      <a
        class="link"
        id="navigate-galleries"
        mat-flat-button
        [class.active-nav-bar-client]="isHeaderLinkActive('/galleries', true)"
        routerLink="/galleries"
      >
        Galleries
      </a>
      <!-- <a
                class="link"
                id="navigate-leads"
                *ngIf="hasLeadsAccessWP$ | async"
                mat-flat-button
                routerLinkActive="active-nav-bar-client"
                (click)="navigateToLeads()"
            >
                Leads
            </a> -->
      <!-- RWE-1770: Removing work in progress
                    <button class="link"
                        mat-flat-button
                        routerLinkActive="active-nav-bar-client"
                        routerLink="/payment"
                        [routerLinkActiveOptions]="{exact:true}"
                >
                    Payment
                </button>
            -->
      <!-- TODO: need need to change or revise logic -->
      <a
        class="link"
        id="navigate-administration"
        mat-flat-button
        [ngClass]="{ 'active-nav-bar-client': hasWordInPath('administration') }"
        routerLink="/administration/dashboard"
      >
        <!--(click)="navigateToAdministration()"-->
        <!--[matMenuTriggerFor]="menuAdmin"-->
        Administration
      </a>
    </div>
    <div *ngIf="canShowReturn()">
      <button
        class="link exclusive"
        id="navigate-back-to-fm"
        mat-flat-button
        (click)="onBackToFormsManagementClicked()"
      >
        Back to Forms Management
      </button>
    </div>
    <div *ngIf="canShowClientLibraryReturn()">
      <button class="link exclusive" id="navigate-back-to-cr" mat-flat-button (click)="onBackToPatient()">
        Back to Client Record
      </button>
    </div>
    <!--        <div *ngIf="canShowBackToClientList()">-->
    <!--            <button class="link exclusive"-->
    <!--                id="navigate-back-to-client-list"-->
    <!--                mat-flat-button-->
    <!--                (click)="onBackToClientList()"-->
    <!--            >-->
    <!--                Back to Client List-->
    <!--            </button>-->
    <!--        </div>-->
    <div *ngIf="canShowGalleriesReturn()">
      <button class="link exclusive" id="navigate-back-to-galleries" mat-flat-button (click)="onBackToGalleries()">
        Back to Galleries
      </button>
    </div>
  </rx-navbar>
  <!--Temporary Commented for the firt beta version-->
  <rx-sub-navbar *ngIf="urlAfterRedirects && canShowSubNav()">
    <!--<div *ngIf="hasWordInPath('account-setting')">-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/account-settings/dashboard/account-management"-->
    <!--&gt;-->
    <!--Account Management-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/account-settings/dashboard/locations"-->
    <!--&gt;-->
    <!--Locations-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/account-settings/dashboard/team"-->
    <!--&gt;-->
    <!--Team-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/account-settings/dashboard/subscription"-->
    <!--&gt;-->
    <!--Subscription-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/account-settings/dashboard/trusted-3rd-party"-->
    <!--&gt; Trusted 3rd Party </button>-->
    <!--</div>-->
    <!--<div *ngIf="hasWordInPath('facesheet')">-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/facesheet/dashboard/clients-tags"-->
    <!--&gt;-->
    <!--Clients Tags-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/facesheet/dashboard/interest-tags"-->
    <!--&gt;-->
    <!--Interest Tags-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/facesheet/dashboard/treatment-tags"-->
    <!--&gt;-->
    <!--Treatment Tags-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/facesheet/dashboard/recommendations"-->
    <!--&gt;-->
    <!--To Do's/Recommendations-->
    <!--</button>-->
    <!--</div>-->
    <!--<div *ngIf="hasWordInPath('client-record')">-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/client-record/dashboard/capture"-->
    <!--&gt;-->
    <!--Capture-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/client-record/dashboard/photos"-->
    <!--&gt;-->
    <!--Photos-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/client-record/dashboard/forms"-->
    <!--&gt;-->
    <!--Forms-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:false}"-->
    <!--routerLink="/administration/client-record/dashboard/notes"-->
    <!--&gt;-->
    <!--Notes-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/client-record/dashboard/content"-->
    <!--&gt;-->
    <!--Content-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--[ngClass]="{'active-nav-bar': hasWordInPath('editor')}"-->
    <!--routerLinkActive="active-nav-bar"-->
    <!--[matMenuTriggerFor]="menu-editor"-->
    <!--&gt;-->
    <!--Editor-->
    <!--</button>-->
    <!--</div>-->
    <!--<div *ngIf="hasWordInPath('consultation-center')">-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/consultation-center/dashboard/education"-->
    <!--&gt;-->
    <!--Education-->
    <!--</button>-->
    <!--<button class="link"-->
    <!--mat-flat-button-->
    <!--routerLinkActive="selected"-->
    <!--[routerLinkActiveOptions]="{exact:true}"-->
    <!--routerLink="/administration/consultation-center/dashboard/galleries"-->
    <!--&gt;-->
    <!--Before/After Galleries-->
    <!--</button>-->
    <!--</div>-->

    <div *ngIf="hasWordInPath('user-setting')">
      <button
        class="link"
        id="navigate-profile"
        mat-flat-button
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLink="/user-setting/dashboard/profile"
      >
        Profile
      </button>
      <!--<button class="link"-->
      <!--mat-flat-button-->
      <!--routerLinkActive="selected"-->
      <!--[routerLinkActiveOptions]="{exact:true}"-->
      <!--routerLink="/user-setting/dashboard/security"-->
      <!--&gt;-->
      <!--Security-->
      <!--</button>-->
      <button
        class="link"
        id="navigate-notifications"
        mat-flat-button
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLink="/user-setting/dashboard/notifications"
      >
        Notifications
      </button>
    </div>
  </rx-sub-navbar>
  <div id="photo-wrapper" class="wrapper flex" [class.patient-record-wrapper]="isPatientRecordRoute()">
    <router-outlet></router-outlet>
  </div>

  <!-- Admin menu-->
  <mat-menu id="menu-admin" #menuAdmin="matMenu">
    <button id="menu-admin-customization" mat-menu-item [matMenuTriggerFor]="menuAdminAppCustomization">
      <rx-list-item
        id="menu-admin-customization-items"
        [title]="'App Customization'"
        [description]="'Customize Capture, Photos, Forms, Notes, Tags etc'"
      ></rx-list-item>
    </button>
    <button id="menu-admin-account-settings" mat-menu-item routerLink="/administration/account-settings">
      <rx-list-item
        id="menuAdmin-account-settings-items"
        [title]="'Account Settings'"
        [description]="'Manage Account, Locations, Team, Subscriptions'"
      ></rx-list-item>
    </button>
  </mat-menu>

  <!-- Admin > App Customization menu-->
  <mat-menu id="menu-admin-austomization" #menuAdminAppCustomization="matMenu">
    <button id="menu-admin-austomization-facesheet" mat-menu-item routerLink="/administration/facesheet">
      <rx-list-item
        id="facesheet"
        [title]="'Facesheet'"
        [description]="'Manage Clinic & Treatment Tags'"
      ></rx-list-item>
    </button>
    <button id="menu-admin-austomization-client-record" mat-menu-item routerLink="/administration/client-record">
      <rx-list-item
        id="client-record"
        [title]="'Client Record'"
        [description]="'Customize Capture, Photos, Forms & Notes'"
      ></rx-list-item>
    </button>
    <button id="menu-admin-austomization-consult-center" mat-menu-item routerLink="/administration/consultation-center">
      <rx-list-item
        id="consultation-center"
        [title]="'Consultation Center'"
        [description]="'Manage Education Center & Before/After Galleries'"
      ></rx-list-item>
    </button>
  </mat-menu>

  <!-- Editor menu-->
  <mat-menu id="menu-editor" #menuEditor="matMenu">
    <button id="menu-editor-content" mat-menu-item [matMenuTriggerFor]="menuEditorContent">
      <rx-list-item
        id="content"
        [title]="'Content'"
        [description]="'Create/edit Content for practice-branded reports'"
      ></rx-list-item>
    </button>
    <button id="menu-editors-forms" mat-menu-item [matMenuTriggerFor]="menuEditorForms">
      <rx-list-item id="forms" [title]="'Forms'" [description]="'Create/edit client and provider forms'"></rx-list-item>
    </button>
    <button id="menu-editors-notes" mat-menu-item [matMenuTriggerFor]="menuEditorNotes">
      <rx-list-item id="note" [title]="'Notes'" [description]="'Create/edit re-usable clinical Notes'"></rx-list-item>
    </button>
  </mat-menu>

  <!-- Editor > Content menu -->
  <mat-menu #menuEditorContent="matMenu">
    <button id="menu-editor-content-manage" mat-menu-item>
      <rx-list-item
        id="manage"
        [title]="'Manage'"
        [description]="'Manage content'"
        routerLink="administration/client-record/dashboard/content/content-manager"
      ></rx-list-item>
    </button>
    <!-- <button mat-menu-item>
            <rx-list-item [title]="'Design'" [description]="'Design content'" routerLink="administration/client-record/dashboard/content/content-editor">
            </rx-list-item>
        </button> -->
  </mat-menu>

  <!-- Editor > Forms menu -->
  <mat-menu id="menu-editor-forms" #menuEditorForms="matMenu">
    <!--
            <button mat-menu-item>
                <rx-list-item [title]="'Consent'" [description]="'Client form verifing consent'" routerLink="administration/client-record/dashboard/editor">
                </rx-list-item>
            </button>
        -->
    <button id="menu-editor-forms-editable" mat-menu-item>
      <rx-list-item
        id="editable"
        [title]="'Editable form'"
        [description]="'Create an editable form.'"
        routerLink="administration/client-record/dashboard/editor"
      ></rx-list-item>
    </button>
    <button id="menu-editor-forms-upload" mat-menu-item>
      <rx-list-item
        id="upload"
        [title]="'Upload'"
        [description]="'Dont want to create it yourself? Upload existing forms'"
      ></rx-list-item>
    </button>
  </mat-menu>

  <!-- Editor > Notes menu -->
  <mat-menu id="menu-editor-notes" #menuEditorNotes="matMenu">
    <button id="menu-editor-notes-btn" mat-menu-item>
      <rx-list-item id="notes" [title]="'Notes Menu Item'" [description]="'Reserved for Notes menu'"></rx-list-item>
    </button>
  </mat-menu>
</ng-container>

<!-- Support menu remains available for non-Intercom actions such as cookie preferences. -->
<app-support-menu />

<ng-template #staticBlock>
  <router-outlet></router-outlet>
</ng-template>
